import { render, staticRenderFns } from "./ClaimTypeSetupGrid.vue?vue&type=template&id=44f0e236"
import script from "./ClaimTypeSetupGrid.vue?vue&type=script&lang=js"
export * from "./ClaimTypeSetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports